import React from 'react';
import PropTypes from 'prop-types';
import { useBreakpointRef } from '../../hooks/useBreakpointRef.js';
var BREAKPOINTS = Object.freeze([724, 900]);
var BREAKPOINT_VALUES = Object.freeze(['24px 16px', '30px 24px', '30px 48px']);

var ChartWrapper = function ChartWrapper(props) {
  var children = props.children;

  var _useBreakpointRef = useBreakpointRef({
    breakpoints: BREAKPOINTS,
    breakpointValues: BREAKPOINT_VALUES
  }),
      ref = _useBreakpointRef.ref,
      padding = _useBreakpointRef.breakpointValue;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "chart-wrapper"
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      padding: padding
    });
  }));
};

ChartWrapper.displayName = "ChartWrapper";
ChartWrapper.propTypes = {
  children: PropTypes.node
};
export { ChartWrapper };